import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import {
  DropdownItemComponent, type DropdownItemComponentProps,
} from '../../../dropdown';

export type AutocompleteItemProps = DropdownItemComponentProps & {
  isSelected?: boolean;
};

export const AutocompleteItem = ({ isSelected, icon, ...dropDownItemProps }: AutocompleteItemProps) => {
  return (
    <DropdownItemComponent
      icon={icon ?? isSelected ? faCheck : undefined}
      {...dropDownItemProps}
    />
  );
};
